// Componentes del módulo de compras (solo transaccionales)
const IndexCompras = () => import('@/components/compras/index/Index-compras.vue');
const NuevaCompra = () => import('@/components/compras/index/nueva-compra/Index-nueva-compra.vue');
const DetalleCompra = () => import('@/components/compras/index/Detalle-compra.vue');
const RemitosDeCompra = () => import('@/components/compras/remitos/Remitos-de-compra.vue');
const NuevoRemitoDeCompra = () => import('@/components/compras/remitos/Nuevo-remito-de-compra.vue');
const DetalleRemitoDeCompra = () => import('@/components/compras/remitos/Detalle-remito-de-compra.vue');
const PagoProveedores = () => import('@/components/compras/pago-proveedores/Pagos.vue');
const DetalleOrdenDePago = () => import('@/components/compras/pago-proveedores/Detalle-orden-de-pago.vue');
const DetalleImputacionProveedor = () => import('@/components/compras/pago-proveedores/Detalle-imputacion-proveedor.vue');

const purchases = {
  path: '/compras',
  redirect: { name: 'Compras' },
  children: [
    // Compras principales
    {
      path: '',
      name: 'Compras',
      component: IndexCompras,
      meta: { title: 'Compras' },
    },
    {
      path: 'nueva',
      name: 'Nueva compra',
      component: NuevaCompra,
      meta: { title: 'Nueva Compra' },
    },
    {
      path: ':purchaseId',
      name: 'Detalle de compra',
      component: DetalleCompra,
      props: true,
      meta: { title: 'Detalle de Compra' },
    },

    // Remitos
    {
      path: 'remitos',
      name: 'Remitos de compra',
      component: RemitosDeCompra,
      meta: { title: 'Remitos de Compra' },
    },
    {
      path: 'remitos/nuevo',
      name: 'Nuevo remito de compra',
      component: NuevoRemitoDeCompra,
      meta: { title: 'Nuevo Remito de Compra' },
    },
    {
      path: 'remitos/:shippingPurchaseId',
      name: 'Detalle de remito de compra',
      component: DetalleRemitoDeCompra,
      props: true,
      meta: { title: 'Detalle de Remito de Compra' },
    },

    // Pagos a proveedores
    {
      path: 'pagos',
      name: 'Pago a proveedores',
      component: PagoProveedores,
      meta: { title: 'Pago a Proveedores' },
    },
    {
      path: 'pagos/:payOrderId',
      name: 'Detalle de orden de pago',
      component: DetalleOrdenDePago,
      props: true,
      meta: { title: 'Detalle de Orden de Pago' },
    },
    {
      path: 'pagos/imputaciones/:allocationId',
      name: 'Detalle de imputacion de proveedor',
      component: DetalleImputacionProveedor,
      props: true,
      meta: { title: 'Detalle de Imputación' },
    },

  ],
};

export default purchases;
